// extracted by mini-css-extract-plugin
export default {"item":"Item_item__w8zEp","item__image":"Item_item__image__j7pXC","item__description":"Item_item__description__z08+R","item__title":"Item_item__title__X8KNL"};